
import './css/contact.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMobileAlt,
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
  faFax,
  faMobile,
} from '@fortawesome/free-solid-svg-icons';


import React from 'react';

function getContactTypeIcon(type)
{
  switch (type)
  {
    case  1: return <FontAwesomeIcon icon={faMobileAlt} />;
    case  2: return <FontAwesomeIcon icon={faEnvelope} />;
    case  3: return <FontAwesomeIcon icon={faMapMarkerAlt} />;
    case 10: return <FontAwesomeIcon icon={faPhone} />;
    case 11: return <FontAwesomeIcon icon={faFax} />;
    case 12: return <FontAwesomeIcon icon={faMobile} />;
    case 13: return <FontAwesomeIcon icon={faEnvelope} />;
    case 20: return <FontAwesomeIcon icon={faMapMarkerAlt} />;
    default: return <FontAwesomeIcon icon={faEnvelope} />;
  }
}

const ContactRow = ({contact}) =>
{
  const c = contact;
  return (
    <div className="contact">
      <div className="contact-type">{ getContactTypeIcon(c.c_type) }</div>
      <div className="contact-name-sal">
        <span className="contact-name" title={c.c_name}>{ c.c_name }</span>
        <span className="contact-sal">{ c.c_sal }</span>
      </div>
      <input type="text" className="contact-num" value={ c.c_num } readOnly={true} />
    </div>
  );
} // end class

const ContactList = ({contacts}) =>
{
  return (
    <div className="contacts">
    { !contacts?'':contacts.map((c,i) =>
      <ContactRow key={`${c.uid}-${c.c_num}/${i}`} contact={c} />
    )}
  </div>
  );
}

export default ContactList;
